// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://kpaixcycljzsxxriyzjh.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtwYWl4Y3ljbGp6c3h4cml5empoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTE0MDQyNjMsImV4cCI6MjA2Njk4MDI2M30.nF1ELs0b4Z-F0SKCo52Mu-Eo1003DzxXlrKhzgusHd8";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});